<template>
  <div class="act">
    <div v-if="showNotice" class="notice-bar">
      <marquee>温馨提示：因运营商系统维护，7月1日至31日每天晚上 23:00 至次日凌晨 6:00 期间暂停下单</marquee>
    </div>
    <!-- <img 
      src="@/assets/GuangzhouUnicomImg/new2/bg.png"
      class="act-bg"
      alt=""
    />
     -->
     <LogoHeader :logoPath="require('@/assets/logo/elm/elm-telecom.png')"
    altText="中国电信"/>
    <img
      class="queryBtn"
      src="@/assets/GuangzhouUnicomImg/queryBtn.png"
      alt=""
      @click="queryOrder"
    />
    <img
      class="kefuBtn"
      src="@/assets/GuangzhouUnicomImg/service.png"
      alt=""
      @click="openKefu"
    />
    <div class="bottomBtn" v-show="bottomBtn">
      <img
        @click="onSubmit"
        class="bottomBtnImg"
        src="@/assets/GuangzhouUnicomImg/lqBtn.png"
        alt=""
      />
    </div>
    <div class="content">
      <img src="@/assets/dxtop.png" class="topImg" alt="" />
      <div class="contentBox1">
        <div class="tcInfo">
          <div class="tcInfoBox">
            <div class="titleBox"><span class="bigText">29</span>元/月（首月30元）</div>
            <div class="contentBox">
              <div class="blueText"><span class="big">1900</span>分钟语音通话</div>
              <div class="blueText">
                <span class="big">141</span>GB流量 
              </div>
              <div class="text">111GB通用流量</div>
              <div class="text">30GB定向流量</div>
              <div class="blueText">
                <span class="big">400</span>条短信（不含彩信）
              </div>
            </div>

            <img
              class="sepeaker"
              src="@/assets/GuangzhouUnicomImg/speaker.png"
              alt=""
            />
            <img
              class="xpImg"
              src="@/assets/GuangzhouUnicomImg/xp.png"
              alt=""
            />
            <div class="bottomBg"></div>
          </div>
        </div>
      </div>
      <div class="contentBox2">
        <div class="userInfo">
          <van-form @submit="onSubmit" :label-width="0">
            <div class="form-item">
              <div class="form-label form-label__reqiured">套餐</div>
              <van-field
                class="form-field"
                v-model="comboName"
                name="cardName"
                placeholder="请选择套餐"
                readonly
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">姓名</div>
              <van-field
                class="form-field"
                v-model="cardName"
                name="cardName"
                placeholder="与身份证一致（已加密）"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">身份证号</div>
              <van-field
                class="form-field"
                v-model="cardNo"
                name="cardNo"
                maxlength="18"
                placeholder="仅用于本次业务（已加密）"
                :rules="[
                  {
                    validator: sfzValidator,
                    message: '请输入正确身份证号码',
                  },
                ]"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">联系电话</div>
              <van-field
                class="form-field"
                v-model="contactsMobile"
                maxlength="11"
                name="contactsMobile"
                placeholder="收货手机号码（已加密）"
                :rules="[{ pattern, message: '请输入正确手机号码' }]"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">号码归属地</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="cardAttribution"
                :value="cardAttribution"
                placeholder="请选择归属地区省市"
              />
              <!-- <van-popup v-model="showPicker" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList2"
                  @confirm="selectCity"
                />
              </van-popup> -->
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">收货城市</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="contactsCity"
                :value="contactsCity"
                placeholder="请选择收货区省市"
                @click="showArea = true"
              />
              <van-popup v-model="showArea" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList"
                  @confirm="onConfirm"
                />
              </van-popup>
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">详细地址</div>
              <van-field
                class="form-field"
                v-model="contactsAddress"
                name="contactsAddress"
                placeholder="请输入详细的收货地址"
              />
            </div>

            <div class="form-item" v-if="false">
              <div class="form-label form-label__reqiured">免费选号</div>
              <van-field
                readonly
                clickable
                class="form-field"
                :value="selNumTips"
                name="comboMobile"
                placeholder="请选择号码"
                />
                <!-- @click="numGuessSelect()" -->
                <van-dialog
                v-model="showMobilePicker"
                :showConfirmButton="false"
                class="numDialog"
              >
                <div class="numClose">
                  <van-icon
                    name="close"
                    @click="showMobilePicker = false"
                    size="1.2rem"
                  />
                </div>
                <div class="numBox">
                  <div
                    v-for="item in numList"
                    :key="item"
                    class="numContent"
                    @click="selcetNum(item)"
                  >
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="numBtn">
                  <van-button
                    icon="replay"
                    type="default"
                    native-type="button"
                    @click="numGuessSelect()"
                    >换一换</van-button
                  >
                </div>
              </van-dialog>
            </div>
            <div class="form-item" v-if="zpActivety">
              <div class="form-label form-label__reqiured">
                {{ simSpiActivity.giftAttrName }}
              </div>
              <van-field
                v-if="sizeList.length <= 1"
                class="form-field"
                :value="giftInfo"
                name="contactsAddress"
                placeholder="请选择赠品尺码"
              />
              <select
                v-else
                class="selectBox"
                v-model="giftInfo"
                @change="changeSize"
              >
                <option value="" disabled selected>请选择尺码</option>
                <option v-for="(item, index) in sizeList" :key="index">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="activeInfo" v-if="zpActivety">
              <div class="activeLeft">{{ simSpiActivity.tips }}</div>
              <div class="activeRight" @click="openTips">
                活动说明
                <van-icon name="question-o" />
              </div>
            </div>
            <div
              class="dealText"
              v-if="dealTextList && dealTextList.length > 0"
            >
              <div class="read">
                <van-checkbox v-model="checkDeal" icon-size="16px" />
                我已阅读并同意
                <span
                  class="deal"
                  @click="toUnicomDeal(item.components)"
                  v-for="(item, index) in dealTextList"
                  :key="index"
                  ><span class="xy">《{{ item.name }}》</span>
                  <!-- {{ index == dealTextList.length - 1 ? "" : "、" }} -->
                </span>
              </div>
            </div>
          </van-form>
          <div class="btn" ref="sumitBtm" @click="onSubmit">
            <img
              class="lqBtn"
              src="@/assets/GuangzhouUnicomImg/lqBtn.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="contentBox1">
        <div class="bmInfo">
          <div class="bmTitle">最新报名用户</div>
          <div class="bmContent">
            <vue-seamless-scroll
              class="scroll-content"
              :class-option="classOption"
              :data="winningList"
            >
              <div
                class="bmItem"
                v-for="(item, index) in winningList"
                :key="index"
              >
                <div class="bmItemName">{{ item.name }}</div>
                <div class="bmItemPhone">{{ item.phone }}</div>
                <div class="bmItemTime">{{ item.time }}分钟前</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <!-- <div class="tcysInfo">
          <img
            class="tcysImg"
            src="@/assets/GuangzhouUnicomImg/new2/tcys.png"
            alt=""
          />
        </div> -->

        <div class="container">
          <div class="header">资费详情</div>
          <div class="content">
            <div class="zfxqTable">
              <div class="zTr">
                <div class="zTh">原月租</div>
                <div class="zTd"><span class="blueText">79元/月</span></div>
              </div>
              <div class="zTr">
                <div class="zTh">原套餐</div>
                <div class="zTd">
                  <span class="blueText">1700分钟</span>语音通话<br>
                  <span class="blueText">11GB</span>流量<br>
                  <span class="blueText">400条</span>短信（不含彩信）
                </div>
              </div>
              <div class="zTr">
                <div class="zTh">现月租<br>(优惠后)</div>
                <div class="zTd"><br><span class="blueText">29元/月(首月30元)</span><br><br></div>
              </div>
              <div class="zTr">
                <div class="zTh">现套餐</div>
                <div class="zTd">
                  <span class="blueText">1900分钟</span>语音通话<br>
                  <span class="blueText">141GB</span>流量<br>
                  <span class="small2">111GB通用流量</span><br>
                  <span class="small2">30GB定向流量</span><br>
                  <span class="blueText">400条</span>短信（不含彩信）
                </div>
              </div>
              <div class="zTr">
                <div class="zTh">合约期</div>
                <div class="zTd"><span class="blueText">24个月</span></div>
              </div>
              <div class="zTr">
                <div class="zTh">套餐外资费</div>
                <div class="zTd">
                  <div class="pBottom">
                    语音0.15元/分钟，流量0.03元/MB，短信0.1元/条。
                  </div>
                  <div>
                    结转：仅基础套餐内11G流量可结转至次月，其余内容均不可结转。
                  </div>
                </div>
              </div>
            </div>
            <div class="section">
              <h3>详细说明：</h3>

              <!-- <p>
                本套餐由39元档次星卡主套餐(包含30GB国内定向流量和125GB国内通用流量)叠加1500分钟语音包组成。
              </p> -->
              <p><strong>29元/月套餐说明：</strong></p>
              <p>活动规则：</p>
              <p>（1）套餐资费补充说明</p>
              <p class="textIndent">
                首月规则：首月流量、通话按天折算。
              </p>
              <p class="textIndent">
                优惠资费：由79元骑士卡基础套餐+200分钟语音包+100GB通用流量包+30GB定向流量包组成，优惠至29元/月。
              </p>
              <p>（2）优惠期：24个月。到期后根据电信政策参与续约或升级。</p>
              <p>（3）套餐外：语音0.15元/分钟，流量0.01元/MB，短/彩信0.1元/条。</p>
              <p class="textIndent">
                结转：仅基础套餐内11G流量可结转至次月，其余内容均不可结转。
              </p>
              <p><strong> 办理说明：</strong></p>
              <p>(1)本卡限蜂鸟骑手办理，一人仅限一张。仅限骑手工作使用，请勿挪作他用。若离职或停止骑手业务，电信有权进行关停处理。</p>
              <p>(2)订单发货后15天内有效。逾期未能激活，本订单将自动失效。</p>
              <p>(3)激活:小程序自助激活。</p>
              
            </div>
          </div>
        </div>

        <!-- <div class="container">
          <div class="header">其他说明</div>
          <div class="content">
            <div class="section">
              <p>1、套餐变更、退订，次月生效。</p>
              <p>
                2、套餐中的"国内"指中国内地，不含港澳台地区。(下同)套餐中包含的语音通话分钟数、短/彩信及手机上网流量仅限中国内地使用，手机上网流量只适用于4G、3G、2G，不区分4G、3G、2G，不含WLAN(Wi-Fi)上网。(下同)。
              </p>
              <p>
                3、套餐内包含的以及赠送的国内通信费不含信息费等代收费。(下同)
              </p>
              <p>
                4、上网当月套餐外流量消费600元及600元的倍数则断网，次月初自动开通，如果客户当月申请继续使用，则继续提供服务，按照套外资费收费。
              </p>
              <p>
                5、本套餐所含定向流量为中国电信联合合作方提供，若合作关系发生变化，中国电信有权对相关内容进行调整或停止提供。若用户不同意调整，可申请终止服务协议。
              </p>
              <p>6、流量抵扣顺序：</p>
              <p class="textIndent">
                定向流量包、不限量视频流量包、赠送闲时流量、闲时流量包、非账单支付假日流量包、1天流量包、3天流量包、7天流量包、30天流量包、畅聊流量包后向全国流量月包、赠送全国流量、5G升级会员包流量、套餐内全国流量、非账单支什流景加餐句，流量加餐包，日海目句后向今困流景委包，非账单支付季/半年/年包流量、季/半年/年包流量、不限量升级包、不限量提速包超出后执行套外流量资费，各省根据省内实际情况微调。
              </p>
            </div>
          </div>
        </div> -->
        <div class="container">
          <div class="header">常见问题</div>
          <div class="content">
            <div class="section">
              <p>1、未满20周岁不能办理新卡入网。</p>
              <p>
                2、请于提交订单15天内激活您的号卡，逾期未能激活的，本订单将自动取消，号卡失效。
              </p>
              <p>
                3、根据工信部要求，您的号卡激活且开通后将由人工对实名照片进行审核，审核不通过的将通过短信方式通知您按要求进行补上传照片操作，逾期若未补上传照片的，号码将被暂停通信服务。
              </p>
              <p>4、50天内已超过3次办理移动号卡拆机业务的用户无法办理此卡。</p>
              <p>5、本套餐不支持副卡。</p>
              <p class="textIndent">套餐条款以页面营销协议为准</p>
              <p>
                6、此卡禁止用于电话销售/推销/金融等类似骚扰诈骗等形式的用途，一旦被投诉或系统监测到会导致停机，无法继续享受优惠或使用。
              </p>
              <p>
                7、产品及相关优惠活动仅限指定互联网渠道销售，产品最终名称以电信系统展示为准。在使用过程中若遇任何问题，可致电18594033399/17502020112客服热线咨询。
              </p>
              <p>
                8、如需销户，可登录中国电信APP或咨询当地10000办理
              </p>
            </div>
          </div>
        </div>
      </div>

      <img
        class="bottomImg"
        src="@/assets/GuangzhouUnicomImg/bottomImg.png"
        alt=""
      />
      <!-- 测试按钮，透明50%，页面底部 -->
      <div class="testBtn">
        <button style="opacity:0.1;width:100px;height:20px;" @click="zhejiangExternalLogin(1)"> </button>
      </div>
      <div class="testBtn">
        <button style="opacity:0.1;width:100px;height:20px;" @click="test2()"> </button>
      </div>
    </div>
    <van-dialog
      v-model="showKefu"
      title="扫码联系客服"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
    >
      <div class="kefuBox">
        <!-- <img
          class="kefuQRCode"
          src="@/assets/GuangzhouUnicomImg/new/kefuQRCode.png"
          alt=""
        /> -->
      </div>
    </van-dialog>
    <van-dialog
      v-model="showSetSize"
      title="赠品尺码"
      confirm-button-text="确定"
      confirm-button-color="#3860cf"
      @confirm="confirmSize"
    >
      <div class="sizeBox">
        <div class="sizeBoxList">
          <div
            :class="['sItem', { active: index == sizeIndex }]"
            @click="changeSize(index)"
            v-for="(item, index) in sizeList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="tipsShow"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
      @confirm="closeTips"
    >
      <div class="dialogTips">
        <img class="tipsImg" :src="tipsImg" alt="" />
      </div>
    </van-dialog>
    <dialogTips
      :text="dialogTips.text"
      :icon="dialogTips.icon"
      :iconColor="dialogTips.iconColor"
      :show="dialogTips.show"
      :confirmButtonText="dialogTips.confirmButtonText"
      @confirm="confirmTips"
    ></dialogTips>
  </div>
</template>

<script>
import {
  Form,
  Field,
  Popup,
  Picker,
  Dialog,
  Icon,
  Checkbox,
  Button,
} from "vant";
import areaData from "../../public/static/areaData.json";
// import operatorData from "../../public/static/operatorData.json";
import { http } from "@/api/http";
import moment from "moment";
import dialogTips from "@/pages/components/dialogTips";
import LogoHeader from "@/components/LogoHeader.vue";
// import Countdown from "./components/Countdown.vue";
// import { deepClone } from "@/utils/utils";
export default {
  name: "ZhejiangTelecom1",
  components: {
    vanForm: Form,
    vanField: Field,
    vanPopup: Popup,
    vanPicker: Picker,
    vanButton: Button,
    vanIcon: Icon,
    vanCheckbox: Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    dialogTips,
    LogoHeader,
    // Countdown,
  },
  data() {
    return {
      areaList: [],
      comboName: "",
      cardName: "",
      cardNo: "",
      contactsMobile: "",
      cardAttribution: "",
      cardAttributionCode: "",
      comboMobile: "",
      selNumTips: "下单后通过短信链接选号",
      contactsCity: "",
      contactsAddress: "",
      columns: [],
      showArea: false,
      showMobile: "",
      checkDeal: true,
      showPicker: false,
      // mapData: [],
      mtBmUid: "",
      spiId: "",
      cardAttributionProvince: "",
      showMobilePicker: false,
      numList: [],
      pattern: /^1[3456789]\d{9}$/,
      // selectCombo: {},
      goodsCode: null,
      dealTextList: [], //协议数据
      areaData: {},
      areaData2: {}, //号码归属地
      saleId: null,
      scrollY: 0,
      bottomBtn: false,
      showBtnTop: 0,
      oIndex: 0,
      comboData: {},
      channel: "",
      winningList: [
        { name: "张**", phone: "137******3", time: 5 },
        { name: "李**", phone: "138******6", time: 7 },
        { name: "欧阳**", phone: "170******1", time: 7 },
        { name: "陈**", phone: "182******6", time: 9 },
        { name: "林**", phone: "187******3", time: 10 },
        { name: "张**", phone: "153******2", time: 10 },
        { name: "黄**", phone: "138******5", time: 11 },
        { name: "王**", phone: "136******1", time: 12 },
        { name: "李**", phone: "182******7", time: 12 },
        { name: "陈**", phone: "189******8", time: 13 },

        // 更多中奖者...
      ],
      classOption: {
        singleHeight: 40,
        waitTime: 5000,
      },
      showKefu: false,
      endTime: moment("2024/12/25 09:59:59").valueOf(),
      isEnded: false,
      sizeList: [
        
      ],
      showSetSize: false,
      giftInfo: "",
      sizeIndex: 0,
      zpActivety: false,
      simSpiActivity: null,
      tipsShow: false,
      tipsImg: "",
      dialogTips: {
        text: "",
        icon: "",
        iconColor: "",
        show: false,
        confirmButtonText: "",
      },
      noClick: false,
      goodsName: "",
      createOrderUrl: "",
      showNotice: false,
    };
  },
  created() {
    this.mtBmUid = localStorage.getItem("mtBmUid");
    this.spiId = localStorage.getItem("gysCode");
    this.saleId = localStorage.getItem("saleId");
    this.oIndex = localStorage.getItem("oIndex");
    this.channel = localStorage.getItem("channel");
    this.areaList = [];
    this.areaList.push(areaData["330000"]);
    // this.areaList.push(areaData["c5ae2ee23e66400cac01eff3246498dd"]);
    // this.initAreaList2();
    this.cardAttribution = "浙江杭州";
    this.cardAttributionProvince = "330000";
    this.cardAttributionCode = "330100";
    this.comboData = {
      comboLevel: 39,
      abstractImg: "",
      comboName: "29元/月骑手卡套餐",
      showMobile: "true",
      goodsCode: this.oIndex,
      comboCode: this.oIndex,
    };

    this.comboName = this.comboData.comboName;
    this.goodsName = this.comboData.comboName;
    // this.dealTextList = [
    //   {
    //     name: "入网协议",
    //     components: "unicomDeal9",
    //   },
    //   {
    //     name: "用户隐私协议",
    //     components: "ysxy",
    //   },
    // ];
    this.simViewLogAdd();
    this.getActivityBySpi();
    this.checkNoticeTime();
  },
  watch: {
    // cardAttribution(newVal, oldVal) {
    //   if (oldVal !== newVal) {
    //     this.comboMobile = "";
    //   }
    // },
    // cardAttribution(newVal, oldVal) {
    //   if (oldVal !== newVal) {
    //     this.comboMobile = "";
    //     let obj = {};
    //     let arr = [];
    //     console.log("newVal =>", newVal);
    //     if (newVal.includes("西藏") || newVal.includes("新疆")) {
    //       if (newVal.includes("西藏")) {
    //         obj = deepClone(areaData["540000"]);
    //       } else if (newVal.includes("新疆")) {
    //         obj = deepClone(areaData["650000"]);
    //       }

    //       this.contactsCity = "";
    //       this.areaData = [];
    //     } else {
    //       obj = deepClone(areaData["gzuni0000000001"]);
    //     }
    //     arr.push(obj);
    //     this.areaList = arr;
    //     console.log("areaList =>", this.areaList);
    //   }
    // },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      const height = this.$refs.sumitBtm.offsetTop;
      this.showBtnTop = height + window.innerHeight;
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    confirmTips() {
      this.dialogTips.show = false;
      this.$forceUpdate();
      if (this.dialogTips.icon == "success") {
        window.location.reload();
      }
    },
    openTips() {
      this.tipsImg = this.simSpiActivity.imgPath;
      // console.log("tipsImg =>",this.tipsImg)
      this.tipsShow = true;
    },
    closeTips() {
      this.tipsShow = false;
    },
    async simViewLogAdd() {
      let params = {
        mtBmUid: this.oIndex,
        spiId: this.spiId,
        clickName: this.oIndex,
        uid: "",
      };
      http("simViewLogAdd", params);
    },
    errorAdd(msg, remark, params) {
      let newParams = {
        mtBmUid: this.oIndex,
        spiId: this.spiId,
        clickName: `ERROR-${this.oIndex}-${msg}`,
        uid: params.contactsMobile,
        remark,
        param: JSON.stringify(params),
      };
      http("simViewLogAdd", newParams);
    },
    confirmSize() {
      this.giftInfo = this.sizeList[this.sizeIndex].value;
    },
    setSize(item) {
      this.giftInfo = item.value;
    },
    changeSize(e) {
      console.log("e =>", e.target.value);
      this.giftInfo = e.target.value;
      // this.sizeIndex = index;
    },
    openSetMeal() {
      this.showSetSize = true;
    },
    ended() {
      this.isEnded = true;
    },
    openKefu() {
      // this.showKefu = true;
      window.location.href =
        "https://work.weixin.qq.com/kfid/kfc2ef46aff0a7d85a6";
    },
    async queryOrder() {
      // window.location.href =
      // "https://m.10010.com/myorder/?isNew=1&entrycode=W002";
      // this.$router.push({
      //   name: "OrderList",
      // });
      let params = {
        spiId: this.spiId,
        openId: this.mtBmUid
      }
      const res = await http("zhenjiangQueryOrder", params);
      if (res && res.code == 200) {
        window.location.href = res.result;
      } else {
        this.$toast(res.message);
      }
    },
    async getActivityBySpi() {
      let params = {
        spiId: this.spiId,
      };

      const res = await http("getActivityBySpi", params, { hideLoading: true });
      console.log("res=>", res);
      if (res && res.code == 200 && res.result.hasActivity) {
        let list = [];
        let sList = JSON.parse(res.result.simSpiActivity.giftSelectList);
        let obj = null;
        sList.map((v) => {
          for (let key in v) {
            obj = {
              name: key,
              value: v[key],
            };
          }
          list.push(obj);
        });
        if (list.length <= 1) {
          this.giftInfo = list[0].value;
        }
        this.sizeList = list;
        this.simSpiActivity = res.result.simSpiActivity;
        this.zpActivety = true;
        this.tipsImg = res.result.simSpiActivity.imgAlertPath;
        this.tipsShow = true;
      } else {
        this.zpActivety = false;
      }
    },
    async onSubmit(values) {
      if (this.noClick) {
        return;
      } else if (!this.checkDeal) {
        this.$toast("请阅读并同意协议");
        return;
      } else if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      }
      //  else if (!this.comboMobile) {
      //   this.$toast("请选择号码");
      //   return;
      // } 
      else if (!this.contactsCity) {
        this.$toast("请选择收货区地址");
        return;
      } else if (!this.contactsAddress) {
        this.$toast("请输入详细的收货地址");
        return;
      } else if (this.contactsAddress.length < 4) {
        this.$toast("详细地址长度不少于4位");
        return;
      } else if (this.zpActivety && !this.giftInfo) {
        this.$toast("请选择赠品尺码");
        return;
      }

      let params = {
        comboLevel: this.comboData.comboLevel,
        comboName: this.comboData.comboName,
        cardAttribution: this.cardAttributionCode,
        goodsName: this.goodsName,
        mtBmUid: this.mtBmUid,
        spiDepartId: this.spiId,
        comboMobile: 'random',
        cardAttributionProvince: this.cardAttributionProvince,
        contactsProvince: this.areaData.pName, // 省
        contactsProvinceCode: this.areaData.pCode, // 省
        contactsCity: this.areaData.cName, // 市
        contactsCityCode: this.areaData.cCode, // 市
        contactsArea: this.areaData.aName, // 区
        contactsAreaCode: this.areaData.aCode, // 区
        comboCode: this.comboData.comboCode,
        goodsCode: this.comboData.goodsCode,
        saleId: this.saleId,
        cardName: this.cardName,
        cardNo: this.cardNo,
        channelCode: "",
        checkCode: "",
        contactsAddress: this.contactsAddress,
        contactsMobile: this.contactsMobile,
        feeType: "",
        numberId: "",
        registerMobile: "",
        tractAddress: "",
        uid: "",
        channel: this.channel,
      };
      // if (this.areaData2.pCode != this.areaData.pCode) {
      //   this.errorAdd("GSDSHDZBYZ", "号码归属省份和收货省份不一致", params);
      //   return this.$toast("号码归属省份需和收货省份一致");
      // }
      if (this.zpActivety) {
        params = {
          ...params,
          giftInfo: this.giftInfo,
        };
      }
      this.noClick = true;
      this.createOrderUrl = "";
      let paramsData = Object.assign(values, params);
      const { code, message, result } = await http("simOrder", paramsData);
      this.noClick = false;
      if (code == 200) {
        this.createOrderUrl = result.shortUrl;
        if (result.shortUrl != null && result.shortUrl != "") {
          //跳转到运营商处理
          window.location.href = result.shortUrl;
          return;
        }
        this.dialogTips = {
          text: "提交成功，即将跳转到办理页面，如有疑问，请联系在线客服处理！",
          icon: "success",
          iconColor: "#07C160",
          show: true,
          confirmButtonText: "确定",
        };
      } else {
        this.dialogTips = {
          text: message,
          icon: "warning",
          iconColor: "#FF4444",
          show: true,
          confirmButtonText: "关闭",
        };
      }
    },
    handleScroll() {
      this.scrollY = window.scrollY;
      if (this.scrollY >= this.showBtnTop) {
        if (!this.bottomBtn) {
          this.bottomBtn = true;
        }
      } else {
        if (this.bottomBtn) {
          this.bottomBtn = false;
        }
      }
      // console.log("Scroll Y position:", this.scrollY);
    },
    selcetNum(item) {
      this.comboMobile = item;
      this.showMobilePicker = false;
    },
    selectCity(values, indexs) {
      // console.log("value =>",value)
      // this.cardAttribution = value.text;
      // this.cardAttributionProvince = value.value;

      this.areaData2 = {
        pName:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
      };
      this.cardAttribution = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      this.showPicker = false;
    },
    onConfirm(values, indexs) {
      this.areaData = {
        pName:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
        aName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].text
            : "", //区
        aCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].code
            : "",
      };
      console.log("areaData =>", this.areaData);
      this.contactsCity = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      // this.mapData = values;
      this.showArea = false;
    },
    sfzValidator(val) {
      return /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
        val
      );
    },

    async numGuessSelect() {
      if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.contactsCity) {
        this.$toast("请选择收货地址");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      }

      let params = {
        spiId: this.spiId,
        cityCode: this.cardAttributionCode,
        goodsId: this.comboData.comboCode,
        provinceCode: this.cardAttributionProvince,
      };
      const { code, result, message } = await http(
        "ltZOPnumGuessSelect2",
        params
      );
      if (code !== 200) return this.$toast(message);
      if (code == 200) {
        console.log("result =>", result);
        this.numList = result;
        this.showMobilePicker = true;
      }
    },
    initAreaList2() {
      let pArr = [];
      let cArr = [];
      let pObj = {};
      let cObj = {};
      let areaList = [];
      areaList.push(areaData["440100"]);
      // areaList.push(areaData["c5ae2ee23e66400cac01eff3246498dd2"]);
      areaList.map((v) => {
        v.children.map((val) => {
          cArr = [];
          val.children.map((value) => {
            cObj = {
              text: value.text,
              code: value.code,
            };
            cArr.push(cObj);
          });
          pObj = {
            text: val.text,
            code: val.code,
            children: cArr,
          };
          pArr.push(pObj);
        });
      });
      console.log("pArr =>", pArr);
      this.areaList2 = [
        {
          text: "",
          code: "0",
          children: pArr,
        },
      ];
    },
    toUnicomDeal(components) {
      this.$router.push({
        name: components,
      });
    },
    getCard() {
      const queryData = Object.assign({}, this.swiperMsg, {
        spiId: this.spiId,
        mtBmUid: this.mtBmUid,
      });
      delete queryData.abstractImg;
      this.$router.push({
        name: "GuangzhouUHanding",
        query: queryData,
      });
    },

        //测试地址
    zhejiangExternalLogin(type) {
      // let params = {
      //   loginType: type
      // };
      // const res = await http("zhejiangExternalLogin", params);
      // console.log("res=>", res);
      // if (res && res.code == 200) {
      //   window.location.href = res.result;
      // }
      console.log("type=>", type);
      window.location.href = "http://qsk-test.gzyxjp.com/?activityId=202001&openId=" + this.mtBmUid;
    },
    test2() {
      console.log("test2=>");
      window.open("http://58.215.200.58:19202/h5/index.html#/pdfPageH5?orderId=testh51753273739000&strTimestamp=1753273740840&strHashCode=414787BDF1080B0F0C273A3026EB30A6");
    },
    checkNoticeTime() {
      const now = new Date();
      const month = now.getMonth() + 1;
      const date = now.getDate();
      const hour = now.getHours();
      // 7月1日至31日
      if (month === 7 && date >= 1 && date <= 31) {
        if (hour >= 23 || hour < 6) {
          this.showNotice = true;
        } else {
          this.showNotice = false;
        }
      } else {
        this.showNotice = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/style/GuangzhouUnicom.less";
.small {
  font-size: 10px;
  // color: #999;
}
.pBottom {
  padding-bottom: 3px;
}
.textIndent {
  padding-left: 10px;
}
.testBtn {
  width:100%;
  display:flex;
  justify-content:space-between;
  margin-top:40px;
  &:last-child {
    justify-content:flex-end;
  }
}
.notice-bar {
  width: 100%;
  background: #fffbe6;
  color: #f30a0a;
  font-size: 20px;
  padding: 6px 0;
  text-align: center;
  border-bottom: 1px solid #ffe58f;
}
.zfxqTable3 {
  border: 1px solid #799ffd;
  border-radius: 10px;
  overflow: hidden;
  .zTr {
    display: flex;
    align-items: stretch;
    border-bottom: 1px solid #799ffd;
    // 不要去掉最后一行的border-bottom
  }
  .zTh, .zTd, .z3Td {
    border-right: 1px solid #799ffd;
  }
  .zTd:last-child, .zTh:last-child, .z3Td:last-child {
    border-right: none;
  }
}

.small2 {
  padding-left: 20px;
  font-size: 13px;
  color: #1f1e1e;
}
</style>
